import { Badge } from '@localagent/ui/components/badge';
import type { IntegrationAction } from '../../types/integrations-types';

const METHOD_COLORS: Record<string, string> = {
  GET: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  POST: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  PUT: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  PATCH: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  DELETE: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
};

export function ActionPreview({ actions }: { actions: IntegrationAction[] }) {
  if (actions.length === 0) {
    return <p className="text-sm text-muted-foreground">No actions defined.</p>;
  }

  return (
    <div className="space-y-2">
      {actions.map((action) => (
        <div key={action.action_key} className="rounded bg-card p-3">
          <div className="flex items-center gap-2">
            <span className={`rounded px-1.5 py-0.5 text-xs font-mono font-medium ${METHOD_COLORS[action.http_method] || 'bg-gray-100'}`}>
              {action.http_method}
            </span>
            <span className="text-sm font-mono text-muted-foreground">{action.path_template}</span>
            {action.pagination && <Badge variant="outline" className="text-xs">Paginated</Badge>}
            {action.response_transform && <Badge variant="outline" className="text-xs">Transformed</Badge>}
          </div>
          <div className="mt-1 text-sm font-medium">{action.name}</div>
          {action.description && <p className="mt-0.5 text-xs text-muted-foreground">{action.description}</p>}
        </div>
      ))}
    </div>
  );
}
